//@flow
import * as React from "react";
import classNames from "classnames";
import "./dimmer.scss";

/*isSmall = width 100px
isMedium = width 200px
isLarge = width 300px
size=*/
const Block = (props: any) => (
  <div
    className={classNames("dimmer-white-gray", props.className)}
    style={{ margin: props.margin, width: props.width, height: props.height }}
    data-width={props.width}>
    {" "}
  </div>
);

export default Block;
